import { Observable } from "rxjs";
import axios from "axios";

const baseUrl = process.env.REACT_APP_BASE_URL;

export default class BaseRequestModel {
    constructor(url, method, headers, body, responseType) {
        this.url = url;
        this.method = method || "GET";
        this.headers = headers || {};
        this.body = body;
        this.responseType = responseType || ''
    }

    request() {
      
        return new Observable(observer => {
            if (this.method === "POST") {
                axios.post(`${baseUrl}${this.url}`, this.body, {
                    "headers": this.headers,
                    responseType: this.responseType
                }).then(function (response) {
                    observer.next(response);
                    observer.complete();
                }).catch((e) => {
                    observer.next(e);
                    observer.complete();
                })
            } else if (this.method === "GET") {
                axios.get(`${baseUrl}${this.url}`, {
                    "headers": this.headers,
                    responseType: this.responseType
                }).then(function (response) {
                    observer.next(response);
                    observer.complete();
                })
                    .catch((e) => {
                        observer.next(e);
                        observer.complete();
                    })
            }

        });
    }
}
